import React from 'react';
import { Icon } from 'semantic-ui-react';
import Modal from '../../../../../../../foundation/components/Modal';
import './StaffTeamMemberModal.css';
var defaultProps = {
  open: false,
  onClose: null
};
export default function StaffTeamMemberModal(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    teamMember = _ref.teamMember;
  return /*#__PURE__*/React.createElement(Modal, {
    open: open,
    onClose: onClose,
    className: "staff-team-member-modal"
  }, /*#__PURE__*/React.createElement(Modal.Header, null, /*#__PURE__*/React.createElement(Icon, {
    name: "close",
    size: "large",
    onClick: onClose
  })), /*#__PURE__*/React.createElement(Modal.Content, null, teamMember));
}
StaffTeamMemberModal.defaultProps = defaultProps;